<template>
  <div class="graph-line-progress-container">
    <div class="graph-line-progress">
      <div class="graph-line-progress-line-container">
        <div class="graph-line-progress-line" :style="ccsVarProgress"></div>
      </div>
      <div class="graph-line-progress-value ml-2" :style="`color: ${color};`">{{ value.toFixed(2) }}%</div>
    </div>

    <div v-if="hint" class="graph-line-progress-hint">
      {{ hint }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLegend: {
      type: Boolean,
      default: false,
    },

    hint: {
      type: String,
    },

    color: {
      type: String,
      default: '#E5D545',
    },

    value: {
      type: Number,
    },
  },

  computed: {
    ccsVarProgress() {
      const percentual = this.fixMinPercentualValue(this.value);
      return {
        '--line-graph-bg-color-left': this.color,
        '--line-graph-width-left': percentual + '%',
      };
    },
  },

  methods: {
    fixMinPercentualValue(percentual) {
      if (percentual > 0 && percentual < 0.5) {
        percentual = 0.5;
      }
      return percentual;
    },
  },
};
</script>
<style lang="scss" scoped>
.graph-line-progress-container {
  .graph-line-progress-title {
    font-size: $font-size-xxxs;
    color: $neutral-color-high-medium;
  }
  .graph-line-progress {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .graph-line-progress-value {
      font-size: $font-size-xxxs;
    }

    .graph-line-progress-line-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 14px;
      border-radius: $border-radius-xg;

      .graph-line-progress-line {
        width: var(--line-graph-width-left);
        background-color: var(--line-graph-bg-color-left);
        height: 14px;
        min-width: 14px;
        border-radius: $border-radius-xg;
      }
    }
  }

  .graph-line-progress-hint {
    font-size: $font-size-xxs;
    color: $neutral-color-high-light;
    float: right;
    margin-top: $spacing-04;
  }
}
</style>
